import type { Ref, SelectHTMLAttributes } from 'react';
import { Icon } from './Icon';
import styles from './Select.module.css';

export interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

export interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'size'> {
  options: SelectOption[];
  size?: 'sm' | 'md';
  invalid?: boolean;
  ref?: Ref<HTMLSelectElement>;
}

/** Native select (best accessibility and mobile UX), styled with tokens. */
export function Select({ options, size = 'md', invalid = false, className, ...rest }: SelectProps) {
  const classes = [styles.select, styles[size], invalid && styles.invalid, className]
    .filter(Boolean)
    .join(' ');
  return (
    <span className={styles.wrapper}>
      <select className={classes} aria-invalid={invalid || undefined} {...rest}>
        {options.map((o) => (
          <option key={o.value} value={o.value} disabled={o.disabled}>
            {o.label}
          </option>
        ))}
      </select>
      <Icon name="chevrons-up-down" size="sm" className={styles.chevron} />
    </span>
  );
}
